export const IN_APP_ICONS_LIST_REQUEST = 'IN_APP_ICONS_LIST_REQUEST';
